import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {Router} from '@angular/router';
import {CollectionService} from '../../../Services/collection.service';
import {ModelService} from '../../../Services/model.service';
import {Model} from '../../../Models/Model';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {concat, Observable, of, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-model-overview',
  templateUrl: './model-overview.component.html',
  styleUrls: ['./model-overview.component.scss']
})
export class ModelOverviewComponent implements OnInit {
  public grid: Grid;
  public modelId: number;
  public modelName: string;
  public models: Observable<Model[]>;
  public modelinput$ = new Subject<string>();
  public modelLoading = false;

  @ViewChild('collectionRowDetail', {static: false}) collectionRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(private router: Router, private modelService: ModelService, private collectionService: CollectionService, private broadcastService: BroadcastService, private translateService: TranslateService) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.model.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.model.code',
          prop: 'code',
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.model.status',
          prop: 'status',
          type: TextColumn.type,
          width: 100,
          minWidth: 100,
          maxWidth: 100,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <TextColumn>{
          name: 'doctrine.model.attach_products',
          prop: 'productCount',
          type: TextColumn.type,
          width: 180,
          minWidth: 180,
          maxWidth: 180,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.model.collection',
          prop: 'collection.name',
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <NumberColumn>{
          name: 'doctrine.model.position',
          prop: 'position',
          maxWidth: 100,
          minWidth: 100,
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.modelService.setPosition(position, row.id).subscribe((res) => {
              this.broadcastService.broadcast('refreshGrid', 'getModel');
            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/model/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/model/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.modelId = row.id;
                this.modelName = row.name.bold();
                this.deleteModal.show();

                // return this.router.navigateByUrl('back-office/property/' + row.id + '/show');
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.modelService,
      rememberURL: this.router.url,
      method: 'getModel',
      defaultSort: 'position',
      rowDetailTemplate: this.collectionRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'collection_id',
          type: 'ng-select',
          label: 'doctrine.attributes.collection',
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          value: new ServiceSearchItem(this.collectionService, 'getCollection', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            options.push({value: 'all', label: this.translateService.instant('global.all')});
            for (const row of res.data) {
              options.push({value: row.id, label: row.name});
            }
            return options;
          })
        }
      ],
    };

  }

  public softDelete() {
    this.modelService.softDeleteModel(this.modelId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getModel');
    });
  }

  private loadModel() {
    const params = new HttpParams();
    this.models = concat(
      of([]), // default items
      this.modelinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter(query => query && query.length > 2),
        tap(() => this.modelLoading = true),
        switchMap((term) => this.modelService.getModelReplace(params.set('query', term)).pipe(
          catchError(() => of([])), // empty list on error
          tap((res) => {
            this.modelLoading = false;
          })
        ))
      )
    );
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/model/archive');

  }

}
